import * as _ from "lodash-es";
import {render} from "./render";
import safeSet from "@fengqiaogang/safe-set";
import {ElForm as Form} from "element-plus";
import {useForm as useValidate} from "./validate";
import {toRaw, ref, defineComponent, nextTick} from "vue";

const autoOption = {
  labelPosition: "top",
};

// 初始化表达数据
const initData = function (form) {
  const data = {};
  const list = _.concat([], form);
  for (const item of list) {
    if (Array.isArray(item)) {
      const value = initData(item);
      Object.assign(data, value);
    } else if (item.children) {
      const value = initData(item.children);
      Object.assign(data, value);
    } else if (item.key) {
      safeSet(data, item.key, item.value);
    }
  }
  return data;
}

export default defineComponent({
  props: {
    items: {
      required: true,
      type: [Array, Object]
    },
    option: {
      type: Object,
      required: false,
    },
  },
  setup (props, {expose, slots, emit}) {
    const state = ref(initData(props.items));
    const {formRef, validate, validateField} = useValidate();

    const onChange = _.debounce(function (value) {
      const keys = _.keys(value);
      const data = {...state.value, ...value};
      state.value = data;
      // 延迟校验修改的字段
      return nextTick(() => validateField(keys));
    }, 80, {
      'leading': true,
      'trailing': false
    });

    const submit = async function () {
      const status = await validate();
      if (status) {
        return toRaw(state.value);
      }
      return false;
    }

    expose({submit});

    return () => {
      const config = {...autoOption, ...props.option};
      return (<div>
        <Form {...config} ref={formRef} model={state.value}>
          {
            _.map(_.concat([], props.items || []), function (value) {
              return render(value, state.value, onChange);
            })
          }
        </Form>
      </div>);
    };
  },
});